module.exports = __webpack_public_path__ + "static/media/logo.dde5b608.png";